var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYolorektMoonWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 108.2 108.2",
    style: {
      enableBackground: "new 0 0 108.2 108.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M42.6,38.5c-2.3,0-4.4,1.9-4.4,4.1s1.9,4.1,4.4,4.1c2.5,0,4.4-1.8,4.4-4.1S44.9,38.5,42.6,38.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28,67.9c-2.3,0-4.4,1.9-4.4,4.1S25.6,76,28,76c2.5,0,4.4-1.8,4.4-4.1S30.4,67.9,28,67.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M80.5,73.3c-2.3,0-4.4,1.9-4.4,4.1c0,2.2,1.9,4.1,4.4,4.1c2.5,0,4.4-1.8,4.4-4.1 C84.9,75.1,82.9,73.3,80.5,73.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M71.7,62.4c-10.3,0-19-8.2-19-18.3s8.7-18.3,19-18.3c10.3,0,18.7,8.2,18.7,18.3S82,62.4,71.7,62.4z M71.6,33 c-6.4,0-11.4,5-11.4,11.1s5.2,11.1,11.5,11.1c6.4,0,11.2-5,11.2-11.1S77.9,33,71.6,33z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M54.1,108.2C24.3,108.2,0,83.9,0,54.1S24.3,0,54.1,0c29.8,0,54.1,24.3,54.1,54.1S84,108.2,54.1,108.2z  M54.1,9.4c-24.8,0-44.8,20-44.8,44.8c0,24.8,20,44.7,44.8,44.7C79,98.9,98.8,79,98.8,54.1C98.8,29.3,79,9.4,54.1,9.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M57.3,87.5c-5.6,0-10.1-4.3-10.1-9.5s4.5-9.5,10.1-9.5c5.6,0,10.1,4.3,10.1,9.5S62.8,87.5,57.3,87.5z  M57.3,74.3c-2.2,0-3.9,1.7-3.9,3.7c0,2.1,1.6,3.8,3.9,3.8c2.2,0,3.9-1.7,3.9-3.8C61.1,75.9,59.5,74.3,57.3,74.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28.4,34c-5.6,0-10.1-4.3-10.1-9.5S22.9,15,28.4,15c5.6,0,10.1,4.3,10.1,9.5S34,34,28.4,34z M28.4,20.7 c-2.2,0-3.9,1.7-3.9,3.7s1.6,3.8,3.9,3.8c2.2,0,3.9-1.7,3.9-3.8S30.7,20.7,28.4,20.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYolorektMoonWhite);
export default __webpack_public_path__ + "static/media/yolorekt_moon-white.1e6eb3d9898dfe5d2f83d3a1984acb64.svg";
export { ForwardRef as ReactComponent };